import { Button } from "components/global";
import Image from "next/image";
import Link from "next/link";
import PropTypes from "prop-types";

const OurServices = ({ service = [] }) => (
	<section className="">
		<div className="">

			<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
				{service?.filter(s => s.isActive).map(s => (
					<ServiceCard key={s._id} title={s.title} img={s.image} id={s._id} />
				))}
			</div>
			<div className="flex justify-center mt-6">
				<Link href="/customer/services">
					<Button outline className="w-fit px-12 py-2">شاهد المزيد</Button>
				</Link>
			</div>
		</div>
	</section>
);

export default OurServices;

const ServiceCard = ({ title, img, id }) => (
	<Link href={`/customer/services/${id}`} className="group block">
		<div className="flex flex-col items-center text-center bg-white rounded-2xl pb-6 overflow-hidden shadow-md">
			<div className="relative w-full aspect-square mb-4 overflow-hidden bg-gray-100 max-h-[300px]">
				<Image
					src={img}
					alt={title}
					layout="fill"
					className="object-cover group-hover:scale-110 transition-transform duration-500"
				/>
				<div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
			</div>
			<h3 className="text-gray-900 font-semibold text-lg group-hover:text-primary-600 transition-colors duration-300">
				{title}
			</h3>
		</div>
	</Link>
);

// PropTypes definitions
ServiceCard.propTypes = {
	title: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
};

OurServices.propTypes = {
	service: PropTypes.arrayOf(PropTypes.object).isRequired,
	title: PropTypes.string,
	description: PropTypes.string,
};

export const ServiceCardSkeleton = () => (
	<div className="text-center animate-pulse inline-block mx-2 md:mx-6">
		{/* Image Placeholder */}
		<div className="w-[220px] h-[300px] bg-gray-200 rounded-xl mx-auto"></div>
		{/* Text Placeholder */}
		<div className="h-4 bg-gray-200 rounded w-20 mx-auto mt-2"></div>
	</div>
);